/* 
Object:         Group change
Description:    Logic and events for the module Group Change 
Used in:        Group change
*/

import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum"

import * as appsettings from "../appsettings"
import * as dialog      from "../dialog"
import * as main        from "../main"
import * as navigation  from "../navigation"
import * as viewmode    from "../viewmode"
import * as grid        from "../grid"

/**
 * initialize overview with all the events bound to the buttons.
 */
export function initialize(userId: number): void {

    // Create new record ...
    $(document)
        .off("click.overviewAdd", "#GroupChangeGrid .k-grid-add")
        .on("click.overviewAdd", "#GroupChangeGrid .k-grid-add", function (e: JQuery.Event): void {

        // Prevent default behaviour
        e.preventDefault();

        // Show mode
        viewmode.setViewMode(ModuleActionViewEnum.Edit);

        // Load create form into the current module div
        navigation.navigateToSpecificUrl("GroupChange/NewItem?userId=" + userId);
    });
    grid.loadGridOptions("GroupChangeGrid");
}

/**
 * delete a item (param is event data)
 */
export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }) {
    const event = e;
    const data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid) {
        // Prevent default behaviour 
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as GroupChangeOverviewVM;

        // Post Data
        $.ajax({
            type: "GET",
            url: appsettings.getUrl("GroupChange/Delete?groupUserId=" + dataItem.GroupUserID),
            success: function () {
                // Refresh datasource grid 
                $("#GroupChangeGrid").data("kendoGrid").dataSource.read();
            }
        });
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

/**
 * update a item (param is event data)
 * @param {JQuery.Event & { currentTarget: HTMLElement }} e
 */
export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    var dataItem = this.dataItem($(e.currentTarget).closest("tr")) as GroupChangeOverviewVM;

    // Edit mode form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("GroupChange/EditItem?groupUserId=" + dataItem.GroupUserID + "&breadcrumbLabel=" + dataItem.GroupLabel);
}

/**
 * show a item (param is event data)
 * @param {JQuery.Event & { currentTarget: HTMLElement }} e
 */
export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Get the data item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as GroupChangeOverviewVM;

    // Show mode form
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("GroupChange/ShowItem?groupUserId=" + dataItem.GroupUserID + "&breadcrumbLabel=" + dataItem.GroupLabel);
}

/**
 * event when the Type selection is changed. according to the selected value some fields will be visible.
 */
export function onTypeChanged(): void {
    setHideTypeFields(this.value());
}

/**
 * event when the Type selection is changed. according to the selected value some fields will be visible.
 * @param {string} selectedType
 */
export function setHideTypeFields(selectedType: string): void {
    main.setHideDivBootstrap("divGroupChange", false);
    main.setHideDivBootstrap("divGroupChangeFrom", false);
    main.setHideDivBootstrap("divGroupChangeTo", false);
    main.setHideDivBootstrap("divWeekdays", false);
    main.setHideDivBootstrap("divGroupChangeStart", false);
    main.setHideDivBootstrap("divGroupChangeStop", false);

    switch (selectedType) {
        case "1":
            main.setHideDivBootstrap("divGroupChange", true);
            break;
        case "2":
            main.setHideDivBootstrap("divGroupChangeFrom", true);
            main.setHideDivBootstrap("divGroupChangeTo", true);
            break;
        case "4":
            main.setHideDivBootstrap("divWeekdays", true);
            main.setHideDivBootstrap("divGroupChangeStart", true);
            main.setHideDivBootstrap("divGroupChangeStop", true);
            break;
    }
}
